<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="20.024"
    viewBox="0 0 18 20.024"
  >
    <path
      d="M20,8h0L14,2.74a3,3,0,0,0-4,0L4,8a3,3,0,0,0-1,2.26V19a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V10.25A3,3,0,0,0,20,8ZM15,20H9V15a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1Zm4-1a1,1,0,0,1-1,1H16V15a3,3,0,0,0-3-3H11a3,3,0,0,0-3,3v5H6a1,1,0,0,1-1-1V10.25a1,1,0,0,1,.34-.75l6-5.25a1,1,0,0,1,1.32,0l6,5.25a1,1,0,0,1,.34.75Z"
      transform="translate(-3 -1.976)"
    />
  </svg>
</template>
<script>
export default {
  name: 'HomeIcon',
};
</script>
